import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import useAuth from '../../../../hooks/useAuth';
import api from '../../../../services/api';

import SectionHeader from '../../../../components/SectionHeader';
import ClassCourseList from './ClassCourseList/index';

interface ApiClass {
  id: string;
  title: string;
  synchronousClassLink: string | null;
}

const StudentClassCoursesList = () => {
  const { user } = useAuth();

  const [classes, setClasses] = useState<ApiClass[]>([]);

  useEffect(() => {
    async function requestClasses() {
      const { data } = await api.get<ApiClass[]>(
        `/students/${user.id}/classes`,
        {},
      );
      setClasses(data);
    }
    requestClasses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MyClassesSection>
      {classes &&
        classes.map(classe => (
          <Fragment key={classe.id}>
            <SectionHeader>
              <h1>{classe.title}</h1>
            </SectionHeader>
            {classe.synchronousClassLink && (
              <ClassLinkContainer>
                <a
                  className="my-classes__class-link-container__link"
                  href={classe.synchronousClassLink}
                >
                  Link de Aula Ao Vivo
                </a>
              </ClassLinkContainer>
            )}
            <ClassCourseList classId={classe.id} />
          </Fragment>
        ))}
    </MyClassesSection>
  );
};

export default StudentClassCoursesList;

// Styled Components

const MyClassesSection = styled.section`
  margin-top: 40px;

  ::-webkit-scrollbar-thumb {
    background: green;
  }

  ::-webkit-scrollbar {
    width: 15px;
  }
`;

const ClassLinkContainer = styled.div`
  background-color: #07224b;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 24px;
  border-radius: 8px;
  max-width: fit-content;
`;

const ClassLink = styled.a`
  font-family: 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
`;
